import React, { useMemo } from 'react';
import {
  validateGuaranteeCompatibility,
  validateRequiredCombinations,
  validateCapitalAmounts,
  validateGuaranteeParameters,
} from '../../validations/validationFunctions';
import ValidationAlert from './ValidationAlert';

function GuaranteeValidationSummary({ formData }) {
  const validationResults = useMemo(() => {
    const results = {
      compatibility: validateGuaranteeCompatibility(formData?.coverages || []),
      combinations: validateRequiredCombinations(formData?.coverages || []),
      capitals: validateCapitalAmounts(formData?.coverages || []),
      parameters: validateGuaranteeParameters(formData?.coverages || []),
    };

    const allErrors = [];
    const allWarnings = [];
    const allSuggestions = [];

    if ((formData?.coverages || []).length === 0) {
      allErrors.push({
        code: 'NO_GUARANTEE_SELECTED',
        message: 'Devi selezionare almeno una garanzia!',
      });
    }

    Object.values(results).forEach((result) => {
      allErrors.push(...result.errors);
      allWarnings.push(...result.warnings);
      allSuggestions.push(...result.suggestions);
    });

    return {
      hasBlockingErrors: allErrors.length > 0,
      hasWarnings: allWarnings.length > 0,
      hasSuggestions: allSuggestions.length > 0,
      errors: allErrors,
      warnings: allWarnings,
      suggestions: allSuggestions,
    };
  }, [formData?.coverages]);

  return (
    <ValidationAlert
      validationResult={validationResults}
      className="mt-3"
    />
  );
}

export default GuaranteeValidationSummary;
